import { render, staticRenderFns } from "./FbError.vue?vue&type=template&id=c9a49a74&scoped=true"
import script from "./FbError.vue?vue&type=script&lang=js"
export * from "./FbError.vue?vue&type=script&lang=js"
import style0 from "./FbError.vue?vue&type=style&index=0&id=c9a49a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a49a74",
  null
  
)

export default component.exports